<template>
  <ekitabu-image
    v-bind="$attrs"
    :src="displaySrc"
    v-on="listeners"
  >
    <template #placeholder>
      <image-loading />
    </template>
    <slot />
  </ekitabu-image>
</template>

<script>
import ImageLoading from "@/components/ImageLoading";
import fallbackCover from "@/assets/img/eKitabu-bug.png";

export default {
  name: "BookCoverImage",
  components: {
    ImageLoading,
  },
  inheritAttrs: false,
  props: {
    src: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hasError: false,
    };
  },
  computed: {
    displaySrc() {
      return this.hasError || !this.src ? fallbackCover : this.src;
    },
    listeners() {
      return {
        ...this.$listeners,
        error: this.onError,
      };
    },
  },
  watch: {
    src() {
      this.hasError = false;
    },
  },
  methods: {
    onError() {
      if (this.hasError) return;
      this.hasError = true;
      if (this.$listeners.error) {
        this.$listeners.error();
      }
    },
  },
};
</script>
